import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import { PageLoader } from "../../../shared_elements";
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";

const AddEditLgSubAssemblies = ({ params, toggleModalFn, addEditLgSubAssemblies, modeType, getResponseBack }) => {
    const [data, setData] = useState(addEditLgSubAssemblies?.data);
    const [error, setError] = useState({ modal : false, data: null});
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [pltConstants, setPltConstants] = useState([])

    useEffect(() => {
        getPltConstants();
    }, [])

    const getPltConstants = () => {
        globalPostService('console/get-constants/', { constant_types: ['lg_position'] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setPltConstants(response.data.data)
                }
            })
    }

    const onFieldChange = (key, value) => {
         setData({...data,[key]:value})
    }

    const isDataChanged = () =>{
        const originalData = addEditLgSubAssemblies?.data || {};
        return(
            data?.name !== originalData?.name ||
            data?.position?.value !== originalData?.position?.value ||
            data?.remarks !== originalData?.remarks
        );
    };

    const onAddEditLgSubAssemblies = () => {
        let validationInputs = {
            name: data?.name?.trim() ? '' : 'Please enter Lg Sub Assemblies Name',
            
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, data);

            payload = {
                id:payload?.id ? payload?.id : null,
                name: payload?.name ? payload?.name : null,
                position: payload?.position ? payload?.position : null,
                remarks: payload?.remarks ? payload?.remarks : null,
            }
            const apiUrl = data?.id ? `config-data/lg-sub-assemblies/bulk-update/` : `config-data/lg-sub-assemblies/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;
            apiMethod(apiUrl,[payload])
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false)
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Lg Sub-Assemblies Data Updated Successfully' : 'Lg Sub-Assemblies Data Added Successfully',
                            page_title: 'Config Data : Lg Sub-Assemblies',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    } else {
                        getResponseBack();
                        setError({ modal: true, data:response?.data?.error_details})
                        setLoading(false)
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Lg Sub-Assemblies Updation Failed' : 'Lg Sub-Assemblies Added Failed',
                            page_title: 'Config Data : Lg Sub-Assemblies',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            item_id: data?.id || null,
                            error_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }
    return (
        <>
            <Dialog
                open={true}
                className='console-management-modal'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit ' : modeType === 'view' ? 'View' : 'Add '} LG Sub-Assembly
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={12}>
                                <TextField
                                    name='name'
                                    label='Name'
                                    disabled={modeType === 'view'}
                                    required
                                    value={data?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 150 }}
                                    onChange={(e) => onFieldChange('name', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.name || ''}
                                    helperText={error?.name || ''}
                                    onFocus={() => setError({ ...error, name: '' })}
                                />
                            </Grid>
                            <Grid item md={12} >
                                <Autocomplete
                                    disabled={modeType === 'view'}
                                    options={pltConstants?.filter(optionItem => optionItem?.type === 'lg_position')}
                                    getOptionLabel={option => option?.label}
                                    name="position"
                                    value={data?.position || null}
                                    onChange={(e, value) => { onFieldChange('position', value); setError({ ...error, 'position': '' }) }}
                                    renderInput={params => <TextField {...params} label="Position" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remark'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Lg Sub-Assemblies', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} Lg Sub-Assemblies form` }) }} color='primary' size='small' variant='outlined'>{modeType === 'view' ? 'Close' : 'Cancel'}</Button>
                    {modeType === 'view' ? null : <Button onClick={() => { onAddEditLgSubAssemblies(); trackActivity('Console Management', { page_title: 'Config Data : Lg Sub-Assemblies', item_type: 'Save Button', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} Lg Sub-Assemblies form` }) }} disabled={isLoading || (modeType === 'edit' && !isDataChanged())} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {error?.data?.map((item) =>
            <ErrorPopUp
             toggleModalFn={() => setError({ modal:false , data: null})}
             modal={error.modal}
             error={item}
             />)}
        </>
    )
}

export default AddEditLgSubAssemblies